export const getImageSuggestionPanelStyles = () => ({
  panel: {
    top: 60,
  },
  panelHeader: {
    paddingLeft: 32,
    paddingRight: 24,
    alignSelf: 'justify-start',
    flexGrow: 1,
  },
  panelTitle: {
    fontSize: 20,
    fontWeight: 600,
    display: 'inline-block',
    lineHeight: '27px',
    paddingBottom: 20,
  },
  backButton: {
    display: 'inline-block',
    paddingRight: 10,
  },
  theme: {
    marginBottom: 14,
    marginLeft: 4,
  },
  buttonContainer: {
    alignItems: 'center',
  },
  errorMessage: {
    marginTop: 16,
  },
});
